import { Component } from "@angular/core";
import { BasePageUpdateComponent, UserService } from 'yt-ng-framework';
import { Drzava } from "../drzava/drzava";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
    selector: 'page-update-test',
    templateUrl: './page-update.component.html'
})

export class PageUpdateComponent extends BasePageUpdateComponent<Drzava> {
    constructor(protected activatedRoute: ActivatedRoute,
                protected userService: UserService,
                protected router: Router){
        super(activatedRoute, userService, router);
    }

    ngOnInit(){
        super.ngOnInit();
    }
}